import React, { useState, useEffect, useRef } from 'react';
import {FaIcon} from '../../common/Icons.jsx';
import LoadingIndicator from '../../common/loading_indicator.jsx';
import Dialog, {DialogHeader} from '../../bootstrap/Dialog.jsx';
import Setting from './setting.jsx';
import {Mode} from '../common.jsx';
import { FormContext } from '../form_context.jsx';
import {fetchJson} from '../../../helpers/fetch.js';

import Datagrid from '../../datagrid/index.jsx';
import AdaliaMEDatagridBase from './adalia_me_datagrid_base.jsx';

import {
  datagrid_get_component_props_json_path,
  datagrid_get_path,
  datagrid_list_json_path,
  datagrid_nbr_of_rows_path
} from '~/routes';

export default class AdaliaMEDatagridFilterAndSummary extends AdaliaMEDatagridBase {
  static contextType = FormContext;

  static get TYPE() {
    return 'adalia_me_datagrid_filter_and_summary';
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.props.pdf) return;

    jQuery.getJSON(datagrid_list_json_path({project_id: this.context.projectId, programme_form_id: this.context.programmeFormId, _options: true}), (data) => {
      this.setState({datagrids: data, context_name: 'datagrid'})
    });
  }

  onSave(answer){
    const datagrid_id = this.props.content.selectedDatagrid;
    const project_id = this.context.projectId;

    fetchJson(datagrid_nbr_of_rows_path({id: datagrid_id, project_id: project_id, programme_form_id: this.context.programmeFormId, _options: true}),{
      method: 'POST',
      body: JSON.stringify({ filter_model: answer })
    }).then(res => {
      this.updateAnswer({filter_model: answer, datagrid_id, project_id, ...res})
      this.setState({showModal: false})
    });
  }

  getParsedRawAnswer() {
    return JSON.parse(this.getRawAnswer() || '{"row_count": 0, "filter_model": {}, "calculated_date": ""}');
  }

  getFilteredRowText(rawAnswer) {
    const {row_count, calculated_date} = rawAnswer;
    return `${row_count} ${I18n.t(
      calculated_date
        ? 'rows_match_applied_filters_at'
        : 'rows_match_applied_filters',
      {scope: 'fe', ...(calculated_date && {at: DT.dt(calculated_date, {datetime: true})})}
    )}`
  }

  renderView() {
    if (this.props.pdf) {
      return (
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <label>
            {this.getText('label')}
          </label>
          {this.descriptionText()}
          <div className='non-printable-component text-muted'>{I18n.t('non_printable_component_placeholder')}</div>
        </div>
      )
    }
    const rawAnswer = this.getParsedRawAnswer();

    return (
      <div style={{display: 'flex', flexDirection: 'column'}}>
        <label className={this.props.content.label_hidden ? 'hidden-label' : ''}>
          <span className="field-label">{this.getText('label')}</span>
        </label>
        {this.descriptionText()}
        {[Mode.FILL, Mode.EDIT].includes(this.props.mode) &&
          <div
            className='border-dashed dark-bg d-flex align-items-center gap-1 p-1 text-color-light flex-dir-column cursor-pointer'
            onClick={(e) => this.toggleModalVisibility(true)}
          >
            <FaIcon type='table' style={{fontSize: '3rem', color: 'rgba(0,0,0,0.3)'}}/>
            <span>
              {I18n.t('click_to_apply_filters_and_view_results_in_grid', {scope: 'fe'})}
            </span>
          </div>
        }

        <div
          className='d-flex justify-content flex-dir-column rounded p-1 mt-1' style={{border: '2px solid rgba(0, 0, 0, 0.2)'}}
          onClick={(e) => {e.preventDefault(); this.toggleModalVisibility(true)}}
        >
          <div className='d-flex justify-content gap-1'>
            <span>{this.getFilteredRowText(rawAnswer)}</span>
          </div>
          {this.props.mode == Mode.VIEW && <a href='#'>{I18n.t('click_to_view')}</a>}
        </div>

        {this.state.showModal &&
          <DatagridFilterAndSummaryDialog
            title={this.getText('label')}
            onClose={this.toggleModalVisibility}
            onSave={this.onSave}
            editable={[Mode.FILL, Mode.EDIT].includes(this.props.mode)}
            saveText={I18n.t('save')}
            datagridId={this.props.content.selectedDatagrid}
            projectId={this.context.projectId}
            programmeFormId={this.context.programmeFormId}
            contextName={this.state.context_name}
            filterModel={rawAnswer['filter_model']}
          />
        }
        <input type='hidden' value={this.getRawAnswer()} name={this.fullFieldName()}/>
      </div>
    );
  }

  renderSettings() {
    const {selectedDatagrid} = this.props.content;
    const {datagrids} = this.state;

    return (
      <div>
        <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings}/>
        <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings}/>
        <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings}/>
        <Setting.TextField
          name='reportKey'
          label={I18n.t('field_report_key', {scope: 'fe'})}
          value={this.props.content.reportKey}
          onChange={this.updateSettings}
          description={I18n.t('field_report_key_description', {scope: 'fe'})}
          componentType={this.constructor.TYPE}
        />
        {datagrids.length &&
          <Setting.Dropdown
            name='selectedDatagrid'
            label={I18n.t('field_selected_datagrid', {scope: 'fe'})}
            value={selectedDatagrid?.toString()}
            onChange={this.updateSettings}
            options={datagrids.map(d => [d.id, d.name])}
          />
        }
      </div>
    );
  }
}

const DatagridFilterAndSummaryDialog = ({onClose, title, onSave, saveText, editable, datagridId, projectId, programmeFormId, contextName = '', filterModel = {}}) => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState({datagrid: {}, context: {}});
  const datagridRef = useRef();

  useEffect(() => {
    if(datagridId) {
      jQuery.getJSON(datagrid_get_component_props_json_path({datagrid_id: datagridId, context_name: contextName, project_id: projectId, programme_form_id: programmeFormId, _options: true}), (data) => {
        setContent({datagrid: data.datagrid, context: data.context});
        setLoading(false)
      })
    }
  }, [datagridId]);

  const header = <DialogHeader onClose={() => onClose(false)} title={title} />;
  const footer = editable && <DialogFooter {...{onSave, saveText, datagridRef}}/>;

  return <Dialog footer={footer} header={header} size={'xl'}>
    {loading && <LoadingIndicator size='sm'/>}
    {Object.keys(content.datagrid).length > 0 && Object.keys(content.context).length > 0  &&
      (<Datagrid
        ref={datagridRef}
        datagrid={content.datagrid}
        context={{
          ...content.context,
          excludePanels: ['columns'],
          query_path: datagrid_get_path({id: datagridId, project_id: projectId, filterModel: {}, _options: true})
        }}
        agGridProps={{
          gridReady: (params) => {
            setTimeout(() => {
              params.api.setFilterModel(filterModel);
            }, 0)
          }
        }}
        supressToolbar={true}
        supressBulkActions={true}
        supressColumnConfiguration={true}
      />)}
  </Dialog>
};

const DialogFooter = ({onSave, saveText, datagridRef}) => (
  <div className='modal-footer'>
    <div className='btn btn-primary' onClick={() => onSave(datagridRef.current.api.getFilterModel())}>{saveText}</div>
  </div>
)
